export const SESSION_PAGE_BANNER_SLOT = 'session-page-banner';

export const SESSION_PAGE_BANNER_PRESENT_TOP_PADDING_CLASS =
  'sm:group-has-[[data-slot=session-page-banner]]/session-page-banner:pt-0';

// Top inset of the card-on-chrome frame (the bottom stays `sm:pb-3`). It
// shrinks by `--app-titlebar-height`, which the main desktop window publishes
// (32px, more when macOS page zoom is below 1) and web / aux windows leave
// unset. Under the title bar the padding floors at 0 so the header row sits
// flush beneath it; where the var is unset it stays the full 12px.
export const SESSION_PAGE_INSET_TOP_PADDING_CLASS =
  'sm:pt-[max(0px,calc(0.75rem-var(--app-titlebar-height,0px)))]';
